import { quoteMessage, siteConfig } from "@latam-energy/content";

export function siteUrl() {
  return import.meta.env.VITE_SITE_URL || siteConfig.domain;
}

export function whatsappHref(message = quoteMessage) {
  return `https://wa.me/${siteConfig.whatsapp}?text=${encodeURIComponent(message)}`;
}

export function formatDate(date: string) {
  return new Intl.DateTimeFormat("es-PE", { dateStyle: "medium", timeZone: "UTC" }).format(new Date(date));
}

export function slugLabel(slug: string) {
  return slug
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
